import { render, staticRenderFns } from "./food_tags.table.vue?vue&type=template&id=6a5d3660&"
import script from "./food_tags.table.vue?vue&type=script&lang=js&"
export * from "./food_tags.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports